import React, { memo } from 'react';
import { ImagePath } from '../../helper/constants';

interface GroOneHeroProps {
  data: any;
  images: {
    background: any;
    mobile: any;
    truck: any;
  };
  urls: {
    googlePlayUrl: string;
    appStoreUrl: string;
  };
  appImages: {
    googlePlay: any;
    appStore: any;
  };
}

const GroOneHero: React.FC<GroOneHeroProps> = memo(({ 
  data, 
  images, 
  urls, 
  appImages 
}) => {
  return (
    <div className="gro-one-slider">
      <section id="hero" className="hero hero-one section dark-background gro-one-app-hero gro-one-app-banner">
    
          <img src={images.background?.thumbnail?.[0]?.url} alt="" className="hero-bg d-xl-block d-lg-block d-md-block  d-sm-none w-100" loading="lazy" decoding="async" />
          <img src={images.mobile?.thumbnail?.[0]?.url}  alt="" className="hero-bg d-xl-none d-lg-none d-md-none d-sm-block w-100" loading="lazy" decoding="async" />

        <div className="container">
          <div className="row gy-4 flex-lg-row-reverse text-md-start text-sm-center justify-content-between">
            <div className=" col-xl-3  col-lg-3 col-md-3"></div>

            <div className=" col-xl-5 col-lg-5 col-md-5 d-flex flex-column justify-content-center" data-aos="fade-in">
              <label className="h1groone banner-h1">
                {data?.field_description?.[0]?.value} 
                <span>{data?.field_title?.[0]?.value}</span>
                {data?.field_sub_title?.[0]?.value}
              </label>
              <div className="d-flex d-sm-none">
                <a href={urls.googlePlayUrl} title={urls.googlePlayUrl}>
                  <img src={appImages.googlePlay?.thumbnail?.[0]?.url} className="img-fluid" alt="Google Play" loading="lazy" decoding="async" />
                </a>
                <a href={urls.appStoreUrl} title={urls.appStoreUrl}>
                  <img src={appImages.appStore?.thumbnail?.[0]?.url} className="img-fluid" alt="App Store" loading="lazy" decoding="async" />
                </a>
              </div>
            </div>
            
            <div className=" col-xl-4  col-lg-4  col-md-4 flex-column hero-img">
              {/* <div className="d-flex align-content-center">
                <img 
                  src={images.mobile?.thumbnail?.[0]?.url} 
                  className="img-fluid mobile-hand-img" 
                  alt="Gro One App Mobile" 
                  data-aos="flip-left" 
                  data-aos-delay="100" 
                  loading="lazy"
                  decoding="async"
                />
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* <img src={images.truck?.thumbnail?.[0]?.url} className="slider-truck" alt="Truck" loading="lazy" decoding="async" /> */}
    </div>
  );
});

GroOneHero.displayName = 'GroOneHero';

export default GroOneHero;
